var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 89.18 41.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Unbenannter_Verlauf_6);}.cls-2{fill:url(#Unbenannter_Verlauf_6-2);}.cls-3{fill:url(#Unbenannter_Verlauf_6-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_6",
    x1: 76.41,
    y1: 20.79,
    x2: 245.2,
    y2: 18.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#415a77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d1b2a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_6-2",
    x1: 76.41,
    y1: 20.36,
    x2: 245.19,
    y2: 17.83,
    xlinkHref: "#Unbenannter_Verlauf_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_6-3",
    x1: 76.5,
    y1: 26.39,
    x2: 245.28,
    y2: 23.85,
    xlinkHref: "#Unbenannter_Verlauf_6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "63.96 0 89.18 0 73.97 41.8 48.75 41.8 63.96 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "35.73 0 60.95 0 45.74 41.8 20.52 41.8 35.73 0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M12.81,12.83H28l-10.55,29H0L9.66,15.27A3.36,3.36,0,0,1,12.81,12.83Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.85d1ce6ea3b4905a05d7a64df430e270.svg";
export { ForwardRef as ReactComponent };